<template>
    <div>
        <form @submit.prevent="onUpdateMinimumCompanyMargins">
            <h2>{{ $t("marginFactorsPanel.Minimum company margins") }}</h2>

            <div
                v-for="(item, index) in minimumCompanyMargins"
                :key="index"
                class="d-flex justify-space-between mt-3"
            >
                <div class="d-flex flex-grow-1">
                    <v-text-field
                        v-model="item.factor"
                        :label="`${$t('marginFactorsPanel.Range')} ${
                            item.range_from
                        }-${item.range_to} ${$t('marginFactorsPanel.factor')}`"
                        variant="outlined"
                        density="compact"
                        type="input"
                    />
                </div>

                <v-btn
                    color="error"
                    class="ml-4 mt-6"
                    variant="flat"
                    size="x-small"
                    @click="onDelete(item.id)"
                >
                    {{ $t("marginFactorsPanel.Delete") }}
                </v-btn>
            </div>

            <div class="d-flex align-center mt-3">
                <v-btn
                    color="primary"
                    variant="flat"
                    size="small"
                    type="submit"
                >
                    {{ $t("marginFactorsPanel.Update") }}
                </v-btn>

                <v-btn
                    color="secondary"
                    class="ml-2"
                    variant="flat"
                    size="small"
                    type="button"
                    @click="onAddNew('minimumCompanyMargin')"
                >
                    {{ $t("marginFactorsPanel.Add a new one") }}
                </v-btn>
            </div>
        </form>

        <hr class="my-5" />

        <form @submit.prevent="onUpdateBaseMargins">
            <h2>{{ $t("marginFactorsPanel.Base margins") }}</h2>

            <div
                v-for="(item, index) in baseMargins"
                :key="index"
                class="d-flex justify-space-between mt-3"
            >
                <div class="d-flex flex-grow-1">
                    <v-text-field
                        v-model="item.factor"
                        :label="`${$t('marginFactorsPanel.Range')} ${
                            item.range_from
                        }-${item.range_to} ${$t('marginFactorsPanel.factor')}`"
                        variant="outlined"
                        density="compact"
                        type="input"
                    />
                </div>

                <v-btn
                    color="error"
                    class="ml-4 mt-6"
                    variant="flat"
                    size="x-small"
                    @click="onDelete(item.id)"
                >
                    {{ $t("marginFactorsPanel.Delete") }}
                </v-btn>
            </div>

            <div class="d-flex align-center mt-3">
                <v-btn
                    color="primary"
                    variant="flat"
                    size="small"
                    type="submit"
                >
                    {{ $t("marginFactorsPanel.Update") }}
                </v-btn>

                <v-btn
                    color="secondary"
                    class="ml-2"
                    variant="flat"
                    size="small"
                    type="button"
                    @click="onAddNew('baseMargin')"
                >
                    {{ $t("marginFactorsPanel.Add a new one") }}
                </v-btn>
            </div>
        </form>

        <v-dialog
            v-model="addMarginModal"
            max-width="700"
            persistent
            scrollable
        >
            <v-card>
                <v-card-title class="text-subtitle-1">
                    {{ $t("marginFactorsPanel.Add a new one") }}
                </v-card-title>

                <v-divider />

                <v-card-text style="max-height: 600px">
                    <v-text-field
                        v-model="modalForm.range_from"
                        :label="$t('marginFactorsPanel.Range from')"
                        variant="outlined"
                        density="compact"
                        type="input"
                    />

                    <v-text-field
                        v-model="modalForm.range_to"
                        :label="$t('marginFactorsPanel.Range to')"
                        variant="outlined"
                        density="compact"
                        type="input"
                    />

                    <v-text-field
                        v-model="modalForm.factor"
                        :label="$t('marginFactorsPanel.Factor')"
                        variant="outlined"
                        density="compact"
                        type="input"
                    />
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />

                    <v-btn variant="flat" size="small" @click="onModalCancel()">
                        {{ $t("marginFactorsPanel.Cancel") }}
                    </v-btn>

                    <v-btn
                        color="secondary"
                        variant="flat"
                        size="small"
                        @click="onModalSave()"
                    >
                        {{ $t("marginFactorsPanel.Save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        minimumCompanyMargins: {
            type: Array,
            required: true,
        },
        baseMargins: {
            type: Array,
            required: true,
        },
    },
    data: () => ({
        addMarginModal: false,
        modalForm: {
            range_from: null,
            range_to: null,
            factor: null,
            type: null,
        },
    }),

    methods: {
        onDelete(id) {
            if (
                !confirm(
                    this.$t(
                        "marginFactorsPanel.Are you sure you want to delete this margin?"
                    )
                )
            ) {
                return;
            }

            this.$inertia.delete(`/margin-factors-panel/${id}`);
        },
        modalFormReset() {
            this.modalForm = {
                range_from: null,
                range_to: null,
                factor: null,
                type: null,
            };
        },
        onAddNew(type) {
            this.modalForm.type = type;
            this.addMarginModal = true;
        },
        onModalCancel() {
            this.addMarginModal = false;

            this.modalFormReset();
        },
        onModalSave() {
            this.$inertia.post("/margin-factors-panel", this.modalForm);

            this.onModalCancel();
        },
        onUpdateMinimumCompanyMargins() {
            if (!confirm("Are you REALLY FUCKING SURE you want to do this?")) {
                return;
            }
            this.$inertia.patch(
                "/margin-factors-panel",
                this.minimumCompanyMargins
            );
        },
        onUpdateBaseMargins() {
            if (!confirm("Are you REALLY FUCKING SURE you want to do this?")) {
                return;
            }
            this.$inertia.patch("/margin-factors-panel", this.baseMargins);
        },
    },
};
</script>
